import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import styles from './HeroTitle.module.scss';

export interface HeroTitleProps {
    title: string | GenericLazyString;
}

export const HeroTitle: React.FC<HeroTitleProps> = (props) => {
    const { title } = props;

    return (
        <div className={styles.HeroTitle}>
            <h1 className={styles.heroHeading}>
                <p>
                    <span className={styles.purpleBackgroundText}>
                        {gettext('EVENTS')}
                    </span>
                    <span className={styles.orangeText}>{gettext('AND')}</span>{' '}
                    <span className={styles.purpleBackgroundText}>
                        {gettext('THINGS TO DO')}
                    </span>
                    <span className={styles.orangeText}>{gettext('NEAR')}</span>{' '}
                </p>
                <p>
                    <span className={styles.greenBackgroundText}>
                        {title.toLocaleUpperCase()}
                    </span>
                </p>
            </h1>
        </div>
    );
};
